import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  panelWrapper: {
    display: "flex",
    flexGrow: 1,
  },
  leftPanel: {
    width: "450px",
    backgroundColor: "#FBFBFC",
    height: "calc(100vh - 90px)",
    overflow: "auto",
    flexShrink: 0,
  },
  rightPanel: {
    flexGrow: 1,
    margin: "0 auto",
    padding: "0 50px",
    maxWidth: "1280px",
    minWidth: "1024px",
    width: "100%",
  },
  wizardContainer: {
    "& .title": {
      fontFamily: "Inter",
      color: "#0F172A",
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(30),
      marginBottom: "15px",
    },
    "& .divider": {
      borderTop: "2px solid #E6E6E6",
      margin: "10px 0px 10px 0px",
    },
  },
  emptyProgressContainer: {
    margin: "60px 0px 60px 0px",
  },
  progressContainer: {
    margin: "20px 0px 30px 0px",
  },
}));
